import { useEffect } from "react";

/**
 * Handles logic specific to when a page is loaded from the browser's
 * back/forward cache (bfcache) instead of being fully remounted.
 *
 * @param onRestore A function to be called when the page is restored from bfcache.
 *
 * @see https://web.dev/articles/bfcache
 */
export const useBfCacheRestore = (onRestore: () => void) => {
  useEffect(() => {
    const handleCachedPageLoad = (evt: PageTransitionEvent) => {
      if (evt.persisted) onRestore();
    };

    window.addEventListener("pageshow", handleCachedPageLoad);
    return () => window.removeEventListener("pageshow", handleCachedPageLoad);
  }, [onRestore]);
};
